module.exports = __webpack_public_path__ + "img/EASTASIA_EGGS.b7c4e22c.png";